import React from 'react';
import './applicationPaneHeader.module.scss';

type Props = {
  plan: string;
};

export class ApplicationPaneHeader extends React.Component<Props> {
  render() {
    const { plan } = this.props;
    return (
      <div styleName="header">
        {plan}
        <br />
        お申し込みフォーム
      </div>
    );
  }
}
